export class PortosModel {
  id: number;
  nome: string;
  id_pais: number = 0;
  iniciais: string;
}



// WEBPACK FOOTER //
// ./src/app/portos/portos.model.ts